(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cp-landing-intro"] && !Shopify.designMode) return;
  try {
    
  function updateLandingJumps() {
    for (const link of document.querySelectorAll('.cp-landing__jumps a[href^="#"]')) {
      link.hidden = !document.getElementById(link.getAttribute('href').slice(1));
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateLandingJumps, { once: true });
  else updateLandingJumps();
  document.addEventListener('shopify:section:load', updateLandingJumps);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(updateLandingJumps));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-product-formats"] && !Shopify.designMode) return;
  try {
    
  class CpFormatCarousel extends HTMLElement {
    connectedCallback() {
      // The element can upgrade while the parser is still inside it, before the track exists.
      if (!this.querySelector('[data-track]') && document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        return;
      }
      this.init();
    }

    init() {
      if (this.track) return;
      this.track = this.querySelector('[data-track]');
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.slides = Array.from(this.track ? this.track.children : []);
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      if (!this.track || this.slides.length < 2) return;

      this.index = -1;
      this.frame = 0;
      this.onScroll = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.sync());
      };
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));
      if (this.prev) this.prev.addEventListener('click', () => this.go(this.index - 1));
      if (this.next) this.next.addEventListener('click', () => this.go(this.index + 1));
      this.sync();
    }

    disconnectedCallback() {
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
    }

    go(index) {
      const target = Math.max(0, Math.min(this.slides.length - 1, index));
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: target * this.track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
    }

    sync() {
      const width = this.track.clientWidth || 1;
      const index = Math.round(this.track.scrollLeft / width);
      if (index === this.index) return;
      this.index = index;
      this.dots.forEach((dot, i) => {
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      this.slides.forEach((slide, i) => {
        if (i === index) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
      });
      if (this.prev) this.prev.toggleAttribute('disabled', index === 0);
      if (this.next) this.next.toggleAttribute('disabled', index === this.slides.length - 1);
    }
  }

  if (!customElements.get('cp-format-carousel')) customElements.define('cp-format-carousel', CpFormatCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
